import { CategoriesSlider } from "./categoryList";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import styled from "styled-components";
import { useCallback, useMemo } from "react";
import smoothScroll from "../../utils/animateScroll";
import { useInputMode } from "../../utils/hooks/useInputMode";

var ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: table;
`;

var ContentInner = styled.div`
  display: table-cell;
  vertical-align: top;
`;

var ScrollingRows = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh);
  background: #121212;
  border-radius: 16px;
  padding: 4rem;
`;

/**
 * Sort items by priority (ascending)
 * Items without priority go to the end
 */
var sortByPriority = function (items) {
  if (!items || !Array.isArray(items)) return [];

  return [...items].sort(function (a, b) {
    var aPriority = a.priority;
    var bPriority = b.priority;

    // Both null - maintain order
    if (aPriority == null && bPriority == null) return 0;
    // Null values go to the end
    if (aPriority == null) return -1;
    if (bPriority == null) return 1;

    // Parse as integers
    var aInt = typeof aPriority === "number"
      ? aPriority
      : parseInt(aPriority, 10) || 999999;
    var bInt = typeof bPriority === "number"
      ? bPriority
      : parseInt(bPriority, 10) || 999999;

    return bInt - aInt;
  });
};

var CategoriesContent = function (props) {
  var data = props.data || {};

  var focusableResult = useFocusable({
    focusKey: "category-genre-parent",
  });
  var ref = focusableResult.ref;
  var focusKey = focusableResult.focusKey;

  var rawCategories = data.categories || [];
  var rawGenres = data.genres || [];

  // Add kind identifier to each item and sort by priority
  var categories = useMemo(function () {
    var items = rawCategories.map(function (item) {
      return Object.assign({}, item, { kind: "category" });
    });
    return sortByPriority(items);
  }, [rawCategories]);

  var genres = useMemo(function () {
    var items = rawGenres.map(function (item) {
      return Object.assign({}, item, { kind: "genre" });
    });
    return sortByPriority(items);
  }, [rawGenres]);

  var inputModeResult = useInputMode();
  var isMouseFocus = inputModeResult.isMouseFocus;
  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var height = focusProps.height;
      var top = focusProps.top;
      smoothScroll(ref, top < 200 ? 0 : top - height / 2, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <ContentWrapper>
      <ContentInner>
        <FocusContext.Provider value={focusKey}>
          <ScrollingRows ref={ref}>
            <CategoriesSlider
              categories={categories}
              rowTitle="دسته بندی ها"
              onFocus={onRowFocus}
              id="main-categories"
            />
            <CategoriesSlider
              categories={genres}
              rowTitle="ژانر ها"
              onFocus={onRowFocus}
              id="main-genres"
            />
          </ScrollingRows>
        </FocusContext.Provider>
      </ContentInner>
    </ContentWrapper>
  );
};

export default CategoriesContent;
